// «سعود» — the /user/saud API (school jwt, the app's usual {status, response} envelope).
//   POST /user/saud/config → {enabled, name, subtitle, welcome, quick_prompts, screenshot, templates, limit, remaining, school}
//   POST /user/saud/chat   {message, page (JSON string ≤ 8 KB), history:[{role:'user'|'saud', text}] (≤ 6), screenshot?}
//                          → {text, actions:[…], remaining, limit, log_id}
//   POST /user/saud/artifact multipart {log_id, kind: pdf|image|excel, name, action, file} → a copy of a file built
//                          here, for the admin's «المحادثات» (upload below)

var OFFLINE = 'تعذّر الاتصال بالخادم. تحقق من الإنترنت وحاول مرة أخرى.';

export function jwt(){
  try { return JSON.parse(localStorage.getItem('user')).jwt || ''; } catch (e) { return ''; }
}

// → { ok: true, data } | { ok: false, message, offline? } (never rejects)
export function call(path, data, timeout){
  return new Promise(function(resolve){
    $.ajax({
      type: 'POST',
      url: window.api + '/user/saud' + path,
      data: Object.assign({ jwt: jwt() }, data || {}),
      timeout: timeout || 30000,
    }).then(function(r){
      if (r && r.status == 100) resolve({ ok: true, data: r.response });
      else resolve({ ok: false, message: (r && typeof r.response == 'string' && r.response) || 'حدث خطأ، حاول مرة أخرى' });
    }).fail(function(x, status){
      resolve({ ok: false, offline: true, message: status == 'timeout' ? 'تأخر الرد من سعود، حاول مرة أخرى.' : OFFLINE });
    });
  });
}

// the server's cap per file (src/saud/saud.js FILE_MAX)
export var UPLOAD_MAX = 8 * 1024 * 1024;

// a copy of a file built in the browser → the conversation's log, for the admin. Fire and forget: never awaited,
// never shown, failures ignored; nothing for an older answer without log_id or a file over 8 MB.
export function upload(logId, kind, blob, name, action){
  try {
    if (!logId || !blob || !blob.size || blob.size > UPLOAD_MAX || !window.FormData || !window.fetch) return;
    var fd = new FormData();
    fd.append('jwt', jwt());
    fd.append('log_id', logId);
    fd.append('kind', kind);
    fd.append('name', name || '');
    if (action != null) fd.append('action', String(action));
    // the real name travels in the field above (a multipart file name is not read as UTF-8)
    fd.append('file', blob, 'saud.' + ({ pdf: 'pdf', image: 'png', excel: 'xlsx' }[kind] || 'bin'));
    fetch(window.api + '/user/saud/artifact', { method: 'POST', body: fd }).catch(function(){});
  } catch (e) { /* never in the user's way */ }
}
